import { render, staticRenderFns } from "./LKRoadmapsFeedLabelConfirm.vue?vue&type=template&id=427bc631&"
import script from "./LKRoadmapsFeedLabelConfirm.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedLabelConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedLabelConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports